import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

/**
 * Spinner — mirrors `.ez-spin` from design/app-tokens.css.
 * 14px ring, 2px border, currentColor so it inherits from text/buttons.
 * Use the Tailwind `animate-spin-fast` keyframe (0.7s) registered in
 * tailwind.config.ts.
 */
export type SpinnerProps = HTMLAttributes<HTMLSpanElement>;

export const Spinner = forwardRef<HTMLSpanElement, SpinnerProps>(
  ({ className, ...props }, ref) => {
    return (
      <span
        ref={ref}
        role="status"
        aria-label="Loading"
        className={cn(
          'inline-block w-3.5 h-3.5 rounded-full border-2 border-current border-r-transparent animate-spin-fast',
          className,
        )}
        {...props}
      />
    );
  },
);
Spinner.displayName = 'Spinner';
